<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <PageHeader title="Manage Blog Posts" subtitle="">
            <router-link :to="{name: 'blog-post-edit'}" slot="top" class="btn btn-primary" style="float: right;margin-top:10px;">
              <i class="icon mdi mdi-plus"></i> &nbsp;Create Blog Post
            </router-link>
            <div class="clearfix"></div>
          </PageHeader>

          <Panel class="panel panel-default panel-border-color panel-border-color-primary">

            <div class="filters">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group form-group-sm row">
                    <label class="col-form-label col-xs-4 control-label">Author</label>
                    <div class="col-xs-8">
                      <select v-model="selectedAuthor" class="form-control">
                        <option v-for="option in authorFilters" v-bind:value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group form-group-sm">
                    <input type="text" class="form-control" placeholder="Search title..." v-model="searchTerm" />
                  </div>
                </div>
                <div class="clearfix">
              </div>
            </div>

            <DynamicTable :data="filteredData" :fields="fields" :onClick="editRecord" :defaultSort="'title'">

            </DynamicTable>

            <div class="settings-container">

            </div><!-- /.main-content -->
          </Panel>
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import Blog from '../../../resources/blog'
  import _ from 'underscore'



  export default {
    components: {
    },

    created() {
      this.$store.dispatch('getBlogPosts');
    },

    methods: {

      editRecord: function (id) {
        const post = _.find(this.blogPosts, function (d) { return d.id === id });
        if (post) {
          this.$router.push({ name: 'blog-post-edit', params: { id: post.id } });
        }
      },

      deletePost(post) {
        if( !confirm(`Are you sure you want to delete '${post.title}?'`)) return;
        this.$store.dispatch('deleteBlogPost', { blogPost:post });
      },

      refreshFilters(posts) {
        for (let i = 0; i < posts.length; i++) {
          var p = posts[i];

          if (_.every(this.authorFilters, function (a) { return a !== p.author })) {
            this.authorFilters.push(p.author);
          }
        }
      },
    },

    computed: {
      ...mapState([
      ]),

      blogPosts() {
        const posts = this.$store.getters.allBlogPosts;
        this.refreshFilters(posts);
        return posts;
      },

      filteredData() {
        let f = {};

        if (this.selectedAuthor) {
          f.author = this.selectedAuthor;
        }

        var filtered = _.where(this.blogPosts, f);

        if (this.searchTerm) {
          var searched = [];
          for (let i = 0; i < filtered.length; i++) {
            if (filtered[i].title.toLowerCase().match(this.searchTerm.toLowerCase() + '.*')) {
              searched.push(filtered[i]);
            }
          }

          return searched;
        } else {
          return filtered;
        }
      }
    },

    data() {
      return {
        fields: ['title', 'author', 'created_at_formatted'],
        authorFilters: [''],
        searchTerm: '',
        selectedAuthor: '',
        errors: [],
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .filters {padding:10px 10px;}
  .filters label {padding-top:8px;}
  .filters .btn {padding:3px 8px;}
  .filters .form-group {margin-bottom:0px;}
</style>



// WEBPACK FOOTER //
// blogmanager.vue?6143fb18